var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFittingCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 52,
    viewBox: "0 0 45 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_61819_16953)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_61819_16953",
    maskUnits: "userSpaceOnUse",
    x: 4.5,
    y: 0,
    width: 36,
    height: 44,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4.5,
    width: 36,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 2C13.6634 2 6.5 9.16344 6.5 18C6.5 25.3862 11.5049 31.6034 18.3083 33.4453L22.5 39.5L26.6917 33.4453C33.4951 31.6034 38.5 25.3862 38.5 18C38.5 9.16344 31.3366 2 22.5 2Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 2C13.6634 2 6.5 9.16344 6.5 18C6.5 25.3862 11.5049 31.6034 18.3083 33.4453L22.5 39.5L26.6917 33.4453C33.4951 31.6034 38.5 25.3862 38.5 18C38.5 9.16344 31.3366 2 22.5 2Z",
    fill: "#B78921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3083 33.4453L19.9527 32.3069L19.5366 31.7058L18.831 31.5148L18.3083 33.4453ZM22.5 39.5L20.8556 40.6384L22.5 43.0136L24.1444 40.6384L22.5 39.5ZM26.6917 33.4453L26.169 31.5148L25.4634 31.7058L25.0473 32.3069L26.6917 33.4453ZM8.5 18C8.5 10.268 14.768 4 22.5 4V0C12.5589 0 4.5 8.05887 4.5 18H8.5ZM18.831 31.5148C12.8772 29.9029 8.5 24.4601 8.5 18H4.5C4.5 26.3122 10.1325 33.3038 17.7856 35.3758L18.831 31.5148ZM24.1444 38.3616L19.9527 32.3069L16.6639 34.5837L20.8556 40.6384L24.1444 38.3616ZM25.0473 32.3069L20.8556 38.3616L24.1444 40.6384L28.3361 34.5837L25.0473 32.3069ZM36.5 18C36.5 24.4601 32.1228 29.9029 26.169 31.5148L27.2144 35.3758C34.8675 33.3038 40.5 26.3122 40.5 18H36.5ZM22.5 4C30.232 4 36.5 10.268 36.5 18H40.5C40.5 8.05887 32.4411 0 22.5 0V4Z",
    fill: "white",
    mask: "url(#path-1-outside-1_61819_16953)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61819_16953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.1666C24.8012 22.1666 26.6667 20.3012 26.6667 18C26.6667 15.6988 24.8012 13.8333 22.5 13.8333C20.1989 13.8333 18.3334 15.6988 18.3334 18C18.3334 20.3012 20.1989 22.1666 22.5 22.1666Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_61819_16953",
    x: 0.5,
    y: 0,
    width: 44,
    height: 51.0137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_61819_16953"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_61819_16953",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61819_16953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(17.5 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFittingCenter);
export default __webpack_public_path__ + "static/media/fitting-center.f7ba08243c4d6fb2bb02cfde913e69c6.svg";
export { ForwardRef as ReactComponent };